module.exports = __webpack_public_path__ + "img/rulers.50759ffd.svg";